import image1 from"../Image/my photo.png";

export const testimonialsData=[
    {
        image: image1,
        review:
        "Hello, I am students of Computer Science and Engineering. I made a code editor where you can compile code online in Html Css and Javascript.In future I will provide you best facility on this platform.",
      name: 'MUKESH CHOUDHARY',
      status: 'STUDENT'
    },
    
];